// Gruppierung von Zeiteinträgen nach LOKALEM Kalendertag (D8).
//
// Die API liefert startTime als UTC-ISO-String. Für die Tagesüberschriften
// im Einträge-Tab zählt aber der lokale Tag des Users: ein Eintrag von
// 00:47 CEST liegt in UTC noch am Vortag (22:47Z) und würde mit
// `toISOString().slice(0, 10)` unter der falschen Überschrift landen.

import { dayKeyFromIso } from './calendar'

/**
 * Gruppiert Einträge nach lokalem Tag (Key `YYYY-MM-DD` in lokaler Zeit),
 * Tage absteigend sortiert (neuester zuerst), Reihenfolge innerhalb eines
 * Tages bleibt die Eingabe-Reihenfolge.
 */
export function groupEntriesByLocalDay<T extends { startTime: string }>(
  entries: readonly T[],
): [string, T[]][] {
  const m = new Map<string, T[]>()
  for (const e of entries) {
    const day = dayKeyFromIso(e.startTime)
    const list = m.get(day) ?? []
    list.push(e)
    m.set(day, list)
  }
  return Array.from(m.entries()).sort((a, b) => b[0].localeCompare(a[0]))
}
